import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterStyle, FilterStyleDisplay } from '../../../../models/common';
import { DecimalFilter, IntegerFilter } from '@lsq-frontend/remote-services/enterprise/common';
import { Utilities } from '../../../../utilities/utilities.helper';
import { BaseFilterComponent } from '../base-filter.component';

@Component({
    selector: 'lsq-number-filter',
    template: `
        <div class="number-filter filter">
            <form [formGroup]="formGroup" (ngSubmit)="emitFilterUpdate()">
                <div class="row">
                    <lsq-select
                        [name]="'filterOptions'"
                        class="col-4"
                        [formGroup]="formGroup"
                        formControlName="filterOptions"
                        [options]="filterOptions"
                    >
                    </lsq-select>
                    <lsq-input
                        *ngIf="!isInteger && !isBetween()"
                        [name]="'value'"
                        class="col-6"
                        type="number"
                        [formGroup]="formGroup"
                        formControlName="value"
                    ></lsq-input>
                    <lsq-input
                        *ngIf="isInteger && !isBetween()"
                        [name]="'value'"
                        class="col-6"
                        digitsOnly="true"
                        [formGroup]="formGroup"
                        formControlName="value"
                    ></lsq-input>
                    <div *ngIf="isBetween()" class="col-6">
                        <div class="row">
                            <lsq-input
                                *ngIf="!isInteger"
                                class="col-6"
                                type="number"
                                [name]="'value'"
                                [formGroup]="formGroup"
                                formControlName="value"
                            ></lsq-input>
                            <lsq-input
                                *ngIf="!isInteger"
                                class="col-6"
                                type="number"
                                [name]="'endValue'"
                                [formGroup]="formGroup"
                                formControlName="endValue"
                            ></lsq-input>
                            <lsq-input
                                *ngIf="isInteger"
                                class="col-6"
                                digitsOnly="true"
                                [name]="'value'"
                                [formGroup]="formGroup"
                                formControlName="value"
                            ></lsq-input>
                            <lsq-input
                                *ngIf="isInteger"
                                class="col-6"
                                digitsOnly="true"
                                [name]="'endValue'"
                                [formGroup]="formGroup"
                                formControlName="endValue"
                            ></lsq-input>
                        </div>
                    </div>
                    <lsq-button class="submit-button col-2" type="submit">Ok</lsq-button>
                </div>
            </form>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./lsq-number-filter.component.scss']
})
export class LsqNumberFilterComponent extends BaseFilterComponent {
    @Input() public filter: DecimalFilter | IntegerFilter;
    @Input() public isInteger = false;

    public filterOptions = Utilities.convertEnumToDisplayArray(FilterStyleDisplay);
    public filterStyleDisplay = FilterStyleDisplay;

    public setFilterValues(): void {
        let filterOption = this.filterOptions[0];
        if (this.filter) {
            if (this.filter.toValue !== null && this.filter.fromValue !== null) {
                filterOption =
                    this.filter.toValue === this.filter.fromValue
                        ? FilterStyleDisplay[FilterStyle.Equal]
                        : FilterStyleDisplay[FilterStyle.Between];
            } else if (this.filter.toValue !== null && this.filter.fromValue === null) {
                filterOption = FilterStyleDisplay[FilterStyle.LessThanOrEqual];
            } else if (this.filter.toValue === null && this.filter.fromValue !== null) {
                filterOption = FilterStyleDisplay[FilterStyle.GreaterThanOrEqual];
            }
        }

        let defaultValue: string | number = '';

        if (this.filter && (this.filter.fromValue !== null || this.filter.toValue !== null)) {
            defaultValue =
                this.filter.fromValue !== null ? this.filter.fromValue : this.filter.toValue;
        }

        this.formGroup = new FormGroup({
            value: new FormControl(defaultValue),
            endValue: new FormControl(
                this.filter &&
                this.filter.toValue !== null &&
                this.filter.toValue !== this.filter.fromValue
                    ? this.filter.toValue
                    : ''
            ),
            filterOptions: new FormControl(filterOption)
        });

        this.formGroup.get('filterOptions').valueChanges.subscribe((val) => {
            this.formGroup.controls.endValue.setValue('');
        });
    }

    public createFormGroup(): FormGroup {
        return new FormGroup({
            filterOptions: new FormControl(this.filterOptions[0]),
            value: new FormControl(''),
            endValue: new FormControl('')
        });
    }

    public emitFilterUpdate(): void {
        const formValue = this.formGroup.value;
        let fromValue = null;
        let toValue = null;

        switch (formValue.filterOptions) {
            case FilterStyleDisplay[FilterStyle.LessThanOrEqual]:
                toValue = formValue.value !== null ? +formValue.value : null;
                break;
            case FilterStyleDisplay[FilterStyle.GreaterThanOrEqual]:
                fromValue = formValue.value !== null ? +formValue.value : null;
                break;
            case FilterStyleDisplay[FilterStyle.Between]:
                if (formValue.value) {
                    fromValue =
                        +formValue.value < +formValue.endValue
                            ? +formValue.value
                            : +formValue.endValue;
                } else {
                    fromValue = null;
                }

                if (formValue.endValue) {
                    toValue =
                        +formValue.value > +formValue.endValue
                            ? +formValue.value
                            : +formValue.endValue;
                } else {
                    fromValue = +formValue.value;
                    toValue = null;
                }
                break;
            default:
                fromValue = formValue.value !== null ? +formValue.value : null;
                toValue = formValue.value !== null ? +formValue.value : null;
        }

        if (this.isInteger) {
            const filterData = {
                [this.column.filterField]: new IntegerFilter({ fromValue, toValue })
            };
            this.updated.emit(filterData);
        } else {
            const filterData = {
                [this.column.filterField]: new DecimalFilter({ fromValue, toValue })
            };
            this.updated.emit(filterData);
        }
    }

    public isBetween(): boolean {
        return this.formGroup.value.filterOptions === this.filterStyleDisplay[FilterStyle.Between];
    }
}
